import branchService from 'ApiService/SuperAdmin/branchService';
import { AuthContext } from 'contexts/AuthContext';
import Nodatafound from 'pages/Common/Nodatafound';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { FaRegEdit } from 'react-icons/fa';
import { BallTriangle } from 'react-loader-spinner';
import { useNavigate } from 'react-router-dom';
import BranchUpdateModel from '../Update/BranchUpdateModel';
import ConfirmationModal from 'pages/Common/ConfirmationModal';

const Index = () => {
  const [branches, setBranches] = useState([]);
  const { state } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updatedBranch, setUpdatedBranch] = useState(null);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const navigate = useNavigate();

  const fetchBranches = async () => {
    setLoading(true);
    try {
      const response = await branchService.allBranches();
      if (response.data.success) {
        setBranches(response.data.allBranches);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to fetch branches.'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (state?.user) {
      fetchBranches();
    }
  }, [state?.user]);

  const handleUpdateClick = (branch) => {
    setUpdatedBranch({ ...branch });
    setShowUpdateModal(true);
  };

  const requestUpdateConfirmation = (event) => {
    event.preventDefault();
    setIsConfirmModalOpen(true);
  };

  const confirmUpdateBranch = async () => {
    setIsConfirmModalOpen(false);
    try {
      const payload = {
        branchId: updatedBranch._id,
        name: updatedBranch.name,
        location: updatedBranch.location,
      };
      const response = await branchService.updateBranch(payload);
      if (response.data.success) {
        toast.success(response.data.message);
        setShowUpdateModal(false);
        fetchBranches();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  return (
    <div className="mt-10 h-full w-full rounded-[20px] md:mt-5">
      {loading ? (
        <div className="flex h-40 items-center justify-center">
          <BallTriangle color="#5431ed" />
        </div>
      ) : branches.length === 0 ? (
        <div className="flex h-40 items-center justify-center dark:text-gray-600">
          <Nodatafound title="No Branches data found" />
        </div>
      ) : (
        <div className="grid w-full grid-cols-1 gap-4 p-2 md:grid-cols-2 lg:grid-cols-3">
          {branches.map((branch) => (
            <span
              key={branch._id}
              className="relative flex flex-col items-center rounded-lg border-2 border-brand-500 dark:border-gray-700 dark:!bg-navy-800 md:flex-row"
            >
              {/* Content Section */}
              <div className="justify flex h-full w-full flex-col p-4 leading-normal md:w-2/3">
                <button
                  onClick={() => handleUpdateClick(branch)}
                  className="absolute right-0 top-1 flex justify-end rounded px-4 py-2 text-gray-900 dark:text-white"
                >
                  <FaRegEdit />
                </button>

                <h5 className="mb-2 w-[80%] text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                  {branch.name}
                </h5>
                <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                  {branch.location || 'Location not available'}
                </p>
              </div>

              {showUpdateModal && (
                <BranchUpdateModel
                  updatedBranch={updatedBranch}
                  setUpdatedBranch={setUpdatedBranch}
                  setShowUpdateModal={setShowUpdateModal}
                  handleUpdateBranch={requestUpdateConfirmation} // Show confirmation modal
                />
              )}
            </span>
          ))}
        </div>
      )}

      {/* Confirmation Modal */}
      <ConfirmationModal
        isOpen={isConfirmModalOpen}
        onClose={() => setIsConfirmModalOpen(false)}
        onConfirm={confirmUpdateBranch}
        title="Confirm Branch Update"
        message={`Are you sure you want to update the branch "${updatedBranch?.name}" with location "${updatedBranch?.location}"?`}
        confirmText="Yes, Update"
        cancelText="Cancel"
        icon="warning"
      />
    </div>
  );
};

export default Index;
